import type { UserProfile } from './models/user';

export enum CommsMessageActions {
  GetEvents = 'getEvents',
  Tabs = 'myYoopTabs',
  InPersonEventsList = 'inPersonEventsList',
  VirtualEventsList = 'virtualEventsList',
  RequestedEventsList = 'requestedEventsList',
  EventDetail = 'EventDetail',
  PublicEventDetail = 'PublicEventDetail',
  ResaleEventsList = 'resaleEventsList',
  Authentication = 'authentication',
  RevokeToken = 'revokeToken',
  ReturnToken = 'returnToken',
  ResendTokenInvite = 'resendTokenInvite',
  AssignTokenToCurrentUser = 'assignTokenToCurrentUser',
  GetConfig = 'getConfig',
  Logout = 'logout',
  UpdateAuthToken = 'updateAuthToken',
}

export interface Response<T> {
  success: boolean;
  error?: Error;
  result?: T;
}

export interface EventDetailRequestData {
  eventId: string;
  marketplaceCode?: string;
}

export interface EventTokenActionData {
  tokenId: string;
}

export interface EventTokenResendInviteData {
  assignmentId: string;
}

export interface AuthenticationResult {
  authenticated: boolean;
  authToken?: string;
  profile?: UserProfile;
}
export interface AuthTokenUpdate {
  authToken: string;
}

export interface GetConfigActionData {
  apiKey: string;
}

export interface MyYoopFilterOptions {
  dateFilterType?: EventDateFilterType;
}

//@FIXME: Duplicated model due to non-buildable dep.
export enum EventDateFilterType {
  NONE = 'NONE',
  CURRENT_AND_FUTURE = 'CURRENT_AND_FUTURE',
  PAST = 'PAST',
}
